<div class="upp-chart-layout" [ngClass]="chartLayoutClass">
    <div class="upp-chart-container">
        <canvas #canvas></canvas>
    </div>

    <div class="upp-chart-legend" *ngIf="legend && legendItems.length > 0">
        <div class="upp-chart-legend-item" *ngFor="let item of legendItems">
            <span class="upp-chart-legend-color" [style.backgroundColor]="item.color"></span>
            <span class="upp-chart-legend-label">{{ item.label }}</span>
            <span class="upp-chart-legend-value" *ngIf="legendShowValue && item.value !== null">{{ formatLegendValue(item.value) }}</span>
        </div>
    </div>
</div>
